export const SPECS = {
  SendFullAddressOnExpressButtons: 'specs.stores.SendFullAddressOnExpressButtons',
  shouldChangeToBiCatalogV2: 'specs.stores.shouldChangeToBiCatalogV2'
};
//# sourceMappingURL=SPECS.js.map